module.exports = __webpack_public_path__ + "static/one-ef524a26c1c420aaa10ba6d451274183.svg";